import React, { useState } from "react";
import Input from "./Input";

const ReactRange = ({ step = 0.1, value, onChange, label, placeholder }) => {
  const min = 0;
  const max = 2000;


  const clamp = (val) => Math.min(max, Math.max(min, val));

  const handleChange = (val) => {
    if (isNaN(val)) return;
    onChange(clamp(val));
  };

  const percentage = ((value - min) / (max - min)) * 100;

  return (
    <div className="flex flex-col items-center space-y-4 w-full">
      {/* Number Input */}
      <Input
        label={label ? label : "Budget"}
        type="number"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => handleChange(parseFloat(e.target.value))}
        placeholder={placeholder ? placeholder : "Enter Budget"}
        className="mt-4 w-full"
      />

      {/* Slider */}
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => handleChange(parseFloat(e.target.value))}
        className="w-full h-2 rounded-lg appearance-none cursor-pointer"
        style={{
          background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${percentage}%, #d1d5db ${percentage}%, #d1d5db 100%)`,
        }}
      />

      {/* Tick labels */}
      <div className="flex justify-between w-full text-xs text-gray-500">
        <span>0</span>
        <span>500</span>
        <span>1K</span>
        <span>1.5K</span>
        <span>2K</span>
      </div>
    </div>
  );
};

export default ReactRange;